import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import "../Css/Testimonial.css";

const testimonials = [
  {
    name: "Priya Sharma",
    text: "I hired a maid through Tanya Maid Service for baby care and home cleaning.",
    img: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    name: "Anil Verma",
    text: "The maid assigned by Tanya Maid Service also cooks and keeps our house clean.",
    img: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    name: "Sunita Joshi",
    text: "Tanya Maid Service made everything simple. Staff is dependable.",
    img: "https://randomuser.me/api/portraits/women/68.jpg",
  },
  {
    name: "Rahul Mehta",
    text: "Very professional and reliable maid service.",
    img: "https://randomuser.me/api/portraits/men/45.jpg",
  },
];

const Testimonial = () => {


  return (
    <section className="testimonial">
      <p className="test-label">TESTIMONIALS</p>
      <h2 className="test-title">Our Clients Feedback</h2>

      <Swiper
  modules={[Navigation, Autoplay]}
  slidesPerView={3}
  spaceBetween={30}
  loop={true}
  speed={800}
  autoplay={{
    delay: 2500,
    disableOnInteraction: false,
  }}
  navigation={{
    prevEl: ".custom-prev",
    nextEl: ".custom-next",
  }}
  breakpoints={{
    0: { slidesPerView: 1 },
    768: { slidesPerView: 2 },
    1024: { slidesPerView: 3 },
  }}
>
        {testimonials.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="test-card">
              <div className="test-header">
                <img src={item.img} alt="" />
                <h4>{item.name}</h4>
              </div>

              <p className="test-text">{item.text}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Arrows */}
      <div className="custom-prev">‹</div>
<div className="custom-next">›</div>
    </section>
  );
};

export default Testimonial;
